export const REVIEW_USER_EMAIL = 'reviewerUsermail';
export const REVIEW_USER_NAME = 'reviewerUsername';
export const HINT_FOR_SPOT_COMMENT = 'hintForSpotComment';
export const HINT_FOR_GENERAL_COMMENT = 'hintForGeneralComment';

export const COMMENT_SENDING_FAILED = 'commentSendingFailed';
export const STATUS_OK = 'statusOk';
